import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { ActivatedRouteSnapshot, ActivationEnd, Data, NavigationEnd, Router } from "@angular/router";
import { NiceVerticalNavigationAppearance } from "@recursyve/nice-ui-kit.v2";
import { throttleTime, withLatestFrom } from "rxjs";
import { filter, map } from "rxjs/operators";
import { AppQuery } from "../../../../store/app.query";

@Component({
    selector: "nerri-navbar",
    standalone: false,
    templateUrl: "./navbar.template.html",
    styleUrls: ["./navbar.style.scss"],
    encapsulation: ViewEncapsulation.None
})
export class NavbarComponent implements OnInit {
    public organisation$ = this.appQuery.organisation$;

    @Input({ required: true })
    public isSmallScreen!: boolean;

    public translationContext = {
        year: new Date().getFullYear()
    };
    public appearance: NiceVerticalNavigationAppearance = "default";
    public shouldHideNav = false;

    public currentAccount = toSignal(this.appQuery.selectCurrentAccount());

    constructor(
        private router: Router,
        private appQuery: AppQuery
    ) {}

    public async ngOnInit(): Promise<void> {
        const initialData = this.getInitialData();
        if (initialData["shortNav"]) {
            this.appearance = "dense";
        }

        if (initialData["hideNav"]) {
            this.shouldHideNav = true;
        }

        const routerData$ = this.router.events.pipe(
            filter(event => event instanceof ActivationEnd),
            throttleTime(0),
            map(e => (e as ActivationEnd).snapshot.data)
        );

        this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                map(navEnd => (navEnd as NavigationEnd).urlAfterRedirects),
                withLatestFrom(routerData$)
            )
            .subscribe(([, data]) => {
                if (data["shortNav"]) {
                    this.appearance = "dense";
                } else {
                    this.appearance = "default";
                }

                if (data["hideNav"]) {
                    this.shouldHideNav = true;
                } else {
                    this.shouldHideNav = false;
                }
            });
    }

    private getInitialData(): Data {
        const state = this.lastRouterChild(this.router.routerState.snapshot.root);
        return state.data;
    }

    private lastRouterChild(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
        if (route.firstChild) {
            return this.lastRouterChild(route.firstChild);
        } else {
            return route;
        }
    }
}
